"use client";

import { useRecoilValue } from "recoil";

import { InfoModal, NotificationModal, ConfirmModal, DynamicHeightConfirmModal, ErrorModal } from "components/GlobalModal/style";
import { useModal } from "hooks/useModal";
import { modalStore } from "store/modalStore";

export const GlobalModal = () => {
  const data = useRecoilValue(modalStore);
  const { closeModal } = useModal();

  if (!data) return null;

  return (
    <>
      <InfoModal data={data} closeModal={closeModal} />
      <NotificationModal data={data} closeModal={closeModal} />
      <ConfirmModal data={data} closeModal={closeModal} />
      <DynamicHeightConfirmModal data={data} closeModal={closeModal} />
      <ErrorModal data={data} closeModal={closeModal} />
    </>
  );
};
